 @if (isLoggedIn) {
    <div class="sidebar-desktop" [class.collapsed]="isCollapsed">
      <div class="sidebar-profile">
        <div class="sidebar-logo" style="margin: 0 auto 16px auto;">
          <img src="/header/png/Ribera_logo.svg" alt="Ribera del Rio" />
        </div>
        <div class="expand-container">
          <div class="expand-button">
            <img src="/header/png/expand_icon.png" alt="Recompensas" (click)="collapseOrExpand()" />
          </div>
        </div>
        <lib-promoters-profile-ui class="only-desktop" [isCollapsed]="isCollapsed"></lib-promoters-profile-ui>
        <!-- <div class="avatar-circle-wrapper">
          <img [src]="avatarUrl" alt="Avatar" class="avatar" />
        </div>
        @if (!isCollapsed) {
          <div class="profile-info">
            <div class="greeting-name" style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
              <span class="greeting">Bienvenido</span>
              <span class="name">{{ loggedUserName }}</span>
            </div>
            <span class="membership">Continua mejorando tu nivel de membresía</span>
          </div>
        }
        <div class="sidebar-actions">
          <button class="sidebar-action"><img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/btn.svg" alt="Notificación" /></button>
          <button class="sidebar-action"><img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/btn+(1).svg" alt="Mail" /></button>
          <button class="sidebar-action"><img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/btn+(2).svg" alt="Teléfono" /></button>
        </div> -->
      </div>
      <nav class="sidebar-links scroll-container">
        <!-- INICIO -->
        <a 
          class="sidebar-link active" 
          routerLink="/dashboard"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/more_horizontal_16px.svg" alt="Inicio" style="margin: 0 12px;" />
          <span>Inicio</span>
        </a>

        <!-- MIS DATOS -->
        <a 
          class="sidebar-link" 
          routerLink="/data"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/user-square.svg" alt="Mis datos" style="margin: 0 12px;" />
          <span>Mis datos</span>
        </a>

        <!-- RESERVAS -->
         @if(!isCollapsed){
          <p-accordion value="0">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <div class="accordion-title">
                  <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/fi-rr-bed.svg" alt="Mis datos" style="margin: -2px 7px -2px 12px;" />
                  Reservas
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div class="sidebar-sublink"
                  routerLink="/bookings"
                  [class.active]="isBookingActive"
                >
                  Disponibles
                </div>
                <div class="sidebar-sublink"
                    routerLink="/member-booking-feature/active-bookings"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                  Reservados
                </div>
                <div class="sidebar-sublink"
                    routerLink="/member-booking-feature/booking-history"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                >
                  Histórico
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        } @else {
          <a 
            class="sidebar-link" 
            routerLink="/bookings"
            [class.active]="isBookingCollapsedActive"
          >
            <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/fi-rr-bed.svg" alt="Reservas" style="margin: 0 12px;" />
            <span>Reservas</span>
          </a>
        }

        <!-- FULLDAY -->
        @if(!isCollapsed){
          <p-accordion value="0">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <div class="accordion-title">
                  <img src="/sidebar/paquetes-fulldays.svg" alt="Fullday" style="margin: -2px 7px -2px 12px;" />
                  Fullday
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div
                  class="sidebar-sublink"
                  routerLink="/member-fullday-feature/disponibles"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  Disponibles
                </div>
                <div
                  class="sidebar-sublink"
                  routerLink="/member-fullday-feature/reservados"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  Reservados
                </div>
                <div
                  class="sidebar-sublink"
                  routerLink="/member-fullday-feature/historico"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  Histórico
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        } @else {
          <div class="sidebar-no-link">
            <img src="/sidebar/paquetes-fulldays.svg" alt="Fullday" style="margin: 0 12px;" />
            <span>Fullday</span>
          </div>
        }

        <!-- EVENTOS -->
        @if(!isCollapsed){
          <p-accordion value="0">
            <p-accordion-panel value="0">
              <p-accordion-header>
                <div class="accordion-title">
                  <img src="/events/client/deco.svg" alt="Eventos" class="events-menu-icon" />
                  Eventos
                </div>
              </p-accordion-header>
              <p-accordion-content>
                <div
                  class="sidebar-sublink"
                  routerLink="/events/disponibles"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: false }"
                >
                  Disponibles
                </div>
                <div
                  class="sidebar-sublink"
                  routerLink="/events/cotizados"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: false }"
                >
                  Cotizados
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        } @else {
          <a
            class="sidebar-link"
            routerLink="/events/disponibles"
            [class.active]="isEventsActive"
          >
            <img src="/events/client/deco.svg" alt="Eventos" class="events-menu-icon collapsed-icon" />
            <span>Eventos</span>
          </a>
        }

        <!-- PROMOCIONES -->
        <a
          class="sidebar-link"
          routerLink="/promotions"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <img
            src="/promoters/member/icon/hot-price.svg"
            alt="Promociones"
            style="width: 18px; height: 18px; margin: 0 12px; object-fit: contain;"
          />
          <span>Promociones</span>
        </a>

        <!-- BENEFICIOS -->
        <a 
          class="sidebar-link" 
          routerLink="/benefits"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/user-double.svg" alt="Beneficios" style="margin: 0 12px;" />
          <span>Beneficios</span>
        </a>

        <!-- RECOMPENSAS -->
        <a 
          class="sidebar-link" 
          routerLink="/dashboard/rewards"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/cup.svg" alt="Recompensas" style="margin: 0 12px;" />
          <span>Recompensas</span>
        </a>

        <!-- BILLETERA -->
        <a 
          class="sidebar-link" 
          routerLink="/dashboard/wallet"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/wallet.svg" alt="Mi wallet" style="margin: 0 12px;" />
          <span>Mi wallet</span>
        </a>

        <!-- PROMOTORES -->
        <a 
          class="sidebar-link" 
          routerLink="/promotor"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <img src="/header/navbar/promoters.svg" alt="Promotor" style="margin: 0 12px;" />
          <span>Promotor</span>
        </a>

      </nav>
      <div  class="sidebar-link link-logout" style="width: 100%; padding: 1rem;"
          class="sidebar-link link-logout"
          (click)="logout()"
          (keypress)="logout()"
          tabindex="0"
        >
          <img src="https://ribera.s3.us-east-1.amazonaws.com/ribera-web-2.0/home/navbar/logout.svg" alt="Recompensas" style="margin: 0 12px;" />
          <span class="logout-label">Cerrar sesión</span>
        </div>
    </div>
}
